import React, { useEffect, useState } from "react";
import {
  Button,
  FormFieldSet,
  useFormHandler,
} from "../../../../../../../components";
import { approvalSelectOptions } from "../../../../../../../assets/data/projectData";
import { ApprovalType } from "../../../../../../../assets/data/enumData";
import { v4 as uuidv4 } from "uuid";
import { useDispatch } from "react-redux";
import { addNewPlacementStart } from "../../../../../../../redux/slices/placements/placementsSlice";
import { filterEmptyValues } from "../../../../../../../utils/filterEmptyValues";
import axiosRequest from "../../../../../../../redux/slices/universal/axiosService";
import { ENDPOINTS } from "../../../../../../../redux/apiConfig";
import { label } from "framer-motion/client";

const ApprovalFlow = ({ setActiveTab, currentPlacement, editData }) => {
  const isEditable = !!editData;
  const dispatch = useDispatch();
  const [fetchPerticularData, setFetchPerticularData] = useState(null);
  const { formData, errors, handleChange, validateAllFields } = useFormHandler(
    {
      approvalFlowList: [
        {
          id: uuidv4(),
          approvalFlow: 1,
          selectManager: "",
        },
      ],
    },
    {
      approvalFlowList: [
        {
          approvalFlow: { type: "select", required: true },
          selectManager: { type: "select", required: true },
        },
      ],
    },
  );

  const handleAddApprover = () => {
    handleChange("approvalFlowList", [
      ...formData.approvalFlowList,
      {
        id: Date.now(),
        approvalFlow: 1,
        selectManager: "",
      },
    ]);
  };

  const handleDeleteApprover = (id) => {
    if (formData.approvalFlowList.length > 1) {
      handleChange(
        "approvalFlowList",
        formData.approvalFlowList.filter((approver) => approver.id !== id),
      );
    }
  };

  const handleSave = () => {
    const isValid = validateAllFields();
    if (isValid) {
      const approvers = formData.approvalFlowList.map((data) => ({
        type: data.approvalFlow,
        id: data.selectManager?.value ?? data.selectManager,
      }));
      const submissionData = filterEmptyValues(approvers);
      console.log("submissionData", submissionData);
      const uiid = fetchPerticularData?.uiid ?? "";
      dispatch(
        addNewPlacementStart({
          uiid: uiid,
          rsd: approvers,
          rsn: "clientPlacementTimesheetApproval",
          payload: [
            {
              type: "SET",
              value: {
                _skipFlatten: ["timesheetDetails.approvers"],
                timesheetDetails: {
                  approvers: approvers,
                },
              },
            },
          ],
          onSuccess: async (payload) => {
            console.log("payload : ", payload);
            setActiveTab((prev) => prev + 1);
          },
        }),
      );
    } else {
      console.log("Validation errors:", errors);
    }
  };
  // useEffect(() => {
  //   const clientPlacementTimesheetApproval = currentPlacement?.clientPlacementTimesheetApproval;
  //   if (clientPlacementTimesheetApproval) {
  //     // Iterate over the object keys (numeric keys)
  //     Object.keys(clientPlacementTimesheetApproval).forEach((key, index) => {
  //       const data = clientPlacementTimesheetApproval[key];
  //       // Update the approvalFlowList for the corresponding index
  //       handleChange(`approvalFlowList[${index}].approvalFlow`, data.type);
  //       handleChange(`approvalFlowList[${index}].selectManager`, data.id); // Correcting the field to `id`
  //     });
  //   }
  // }, [currentPlacement]);

  useEffect(() => {
    const fetchData = async () => {
      const uiid =
        currentPlacement?.uiid ??
        editData?.uiid ??
        currentPlacement?.data?.doc?.uiid ??
        "";
      if (!uiid) return;
      const filter = {
        uiid: { type: "NONE", value: uiid },
      };
      try {
        const response = await axiosRequest({
          method: "GET",
          url: ENDPOINTS.PLACEMENTS.GET_BY_UIID,
          params: {
            coll: "Placement",
            fil: JSON.stringify(filter),
            ret: "timesheetDetails.approvers uiid",
            ref: "Approver",
            incl: ["firstName lastName"],
          },
        });
        const data = response?.data?.data;
        if (data) {
          setFetchPerticularData(data);
          const clientPlacementTimesheetDeatils =
            data?.timesheetDetails?.approvers || [];
          if (clientPlacementTimesheetDeatils) {
            // Iterate over the object keys (numeric keys)
            Object.keys(clientPlacementTimesheetDeatils).forEach(
              (key, index) => {
                const data = clientPlacementTimesheetDeatils[key];
                // Update the approvalFlowList for the corresponding index
                handleChange(
                  `approvalFlowList[${index}].approvalFlow`,
                  data.type,
                );
                handleChange(`approvalFlowList[${index}].selectManager`, {
                  label: `${data.id[0]?.firstName} ${data.id[0]?.lastName} (EMP-${data.id[0]?.uiid})`,
                  value: data.id[0]?.uiid,
                });
              },
            );
          }
        }
      } catch (error) {
        setFetchPerticularData(null);
        console.error("Failed to fetch placement data:", error);
      }
    };

    fetchData();
  }, [currentPlacement, isEditable]);

  return (
    // <div className="w-full px-8 py-4 border-[1px] border-neutrals-50 rounded-b min-h-[65vh] overflow-auto">
    <div className="w-full px-8 py-4 border-[1px] border-neutrals-50 rounded-b overflow-auto">
      <div className="grid grid-cols-[1fr_1fr_135px] lg:grid-cols-3 max-w-7xl gap-x-8 gap-y-6 items-start ">
        {formData.approvalFlowList.map((approver, index) => (
          <React.Fragment key={approver.id}>
            <div className="col-span-1">
              <FormFieldSet
                type="select"
                title="Approval Flow"
                placeholder="Select"
                value={approver.approvalFlow}
                onChange={(value) =>
                  handleChange(`approvalFlowList[${index}].approvalFlow`, value)
                }
                error={errors.approvalFlowList?.[index]?.approvalFlow}
                options={ApprovalType}
              />
            </div>
            <div className="col-span-1 ">
              <FormFieldSet
                type="employeesSortedNonBillable"
                // type="users"
                showSearch
                title=""
                placeholder="Select"
                value={approver.selectManager}
                onChange={(value) =>
                  handleChange(
                    `approvalFlowList[${index}].selectManager`,
                    value,
                  )
                }
                error={errors.approvalFlowList?.[index]?.selectManager}
                // options={approvalSelectOptions}
              />
            </div>
            <div className="col-span-1 flex justify-center items-start gap-2 mt-5">
              {index === 0 ? (
                <Button
                  icon="add"
                  color="black"
                  title="Add more"
                  onClick={handleAddApprover}
                />
              ) : (
                <Button
                  type="icon"
                  icon="delete"
                  title=""
                  variant="text"
                  color="danger"
                  onClick={() => handleDeleteApprover(approver.id)}
                />
              )}
            </div>
          </React.Fragment>
        ))}
      </div>
      <div className="flex gap-3 justify-end mt-6">
        <Button title="Cancel" variant="outlined" />
        <Button title="Save" onClick={() => handleSave()} />
      </div>
    </div>
  );
};

export default ApprovalFlow;
